export default __webpack_public_path__ + "static/media/image07.594703e4.jpg";